import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".target-project-menu",
    attrs: {
      sections: this.helpers.projectListSections()
    },
    on: {
      clickItem: this.helpers.fireProjectSelectedEvent
    }
  }));
}
